module.exports = __webpack_public_path__ + "static/8-ce27a275447f58be98a1ea8f33894104.jpg";